export const MISSING_STRING = '?';
export const MISSING_NUMBER = 0;
export const NOT_FOUND_INDEX = -1;
